import React from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import IconButton from '@mui/material/IconButton';
import Input from 'pages/Dashboard/components/Input';
import Select from 'core/components/Select';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import ToolTip from 'core/components/Tooltip';
import {
  FieldComponentProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import {
  DeleteIcon,
} from 'core/icons';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import PatientHistoryAutoComplete from 'views/EMR/components/PatientHistoryAutoComplete';

const relations = ['Parent', 'Sibling', 'Child'];

export default function FamilyMedicalInfo({
  showLabel,
  index,
  onDelete,
  prefix,
}: FieldComponentProps) {
  const dltBtnClasses = clsx({ 'relative !top-2': showLabel });
  const { control } = useFormContext();
  const key = `${prefix}.${index}`;

  return (
    <div className="flex items-center gap-4">
      <Controller
        name={`${key}.diseaseName`}
        rules={{ required: true }}
        control={control}
        render={({ field, fieldState: { invalid } }) => (
          <Wrapper
            id="family-medical"
            label={showLabel ? 'Family Medical Issues' : ''}
            className="w-full"
            error={invalid}
            showErrorText={false}
            required={showLabel}
          >
            <PatientHistoryAutoComplete
              {...field}
              id="familyHistorySettings"
              placeholder="Family Medical Issues"
            />
          </Wrapper>
        )}
      />
      <Controller
        name={`${key}.diseaseDescription`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            error={!isNil(error)}
            showErrorText={false}
            value={field.value ?? ''}
            className="w-2/4"
            labelClasses="text-gray-500 text-xs"
            label={showLabel ? 'Disease Description' : ''}
            placeholder="Disease Description"
            id="disease-description"
          />
        )}
      />
      <Controller
        name={`${key}.familyRelation`}
        control={control}
        render={({ field }) => (
          <Select<string>
            {...field}
            id="relation-option"
            label={showLabel ? 'Relation' : ''}
            labelClasses="text-gray-500 text-xs"
            className="min-w-24"
            options={relations}
            getLabel={(option: string) => option}
            getValue={(option: string) => option}
          />
        )}
      />
      <ToolTip title="Delete">
        <span>
          <IconButton
            className={dltBtnClasses}
            onClick={() => { onDelete(index); }}
            color="error"
          >
            <DeleteIcon className="text-gray-400 !w-5 !h-5" />
          </IconButton>
        </span>
      </ToolTip>
    </div>
  );
}
